import sanityClient from '@sanity/client';
import sanityConfig from '../sanity.json';

export default sanityClient({
  projectId: sanityConfig.api.projectId,
  dataset: sanityConfig.api.dataset,
  apiVersion: sanityConfig.api.apiVersion,
  useCdn: true, // `false` if you want to ensure fresh data
});
